import PropTypes from 'prop-types'
import defaults from '@config/defaults'
import { NextSeo } from 'next-seo'
import Hero from '@components/custom-hero'
import ErrorBoundary from '@components/error/boundary'
import ContentSectionsQuery from './content-section.query'
import useStyles from './custom-page.styles'

const CustomPage = (props) => {
  const {
    pageTitle,
    pageDescription,
    metaImage,
    slug,
    route,
    includeSubNav,
    query,
    quickLinks,
  } = props
  const hasQuickLinks = !!quickLinks?.heading
  const styles = useStyles({ hasQuickLinks })

  return (
    <div className={styles.other}>
      <NextSeo
        noindex={defaults.noindexNofollow}
        nofollow={defaults.noindexNofollow}
        title={pageTitle}
        description={pageDescription}
        canonical={`${defaults.baseUrl}${route.substring(1)}${slug}`}
        openGraph={{
          title: pageTitle,
          type: 'article',
          url: `${defaults.baseUrl}${route.substring(1)}${slug}`,
          images: [{ url: (metaImage && metaImage.url) }],
        }}
      />
      <ErrorBoundary>
        <Hero {...props} />
      </ErrorBoundary>
      <ErrorBoundary>
        <ContentSectionsQuery
          route={route}
          slug={slug}
          includeSubNav={includeSubNav}
          preview={query.preview}
        />
      </ErrorBoundary>
    </div>
  )
}

CustomPage.propTypes = {
  pageTitle: PropTypes.string,
  pageDescription: PropTypes.string,
  slug: PropTypes.string,
  route: PropTypes.string,
  query: PropTypes.object.isRequired,
  heroSummary: PropTypes.object,
  includeSubNav: PropTypes.bool,
  metaImage: PropTypes.shape({
    url: PropTypes.string,
  }),
  quickLinks: PropTypes.object,
}

export default CustomPage
